import { useState } from 'react'
import { Group, Radio, useMantineTheme } from '@mantine/core'

import classes from './RadioInput.module.css'
import type { RadioInputProps } from './RadioInput.types'

export function RadioInput({
  data,
  initValue,
  onChange,
  ...props
}: RadioInputProps) {
  const [checkedOption, setCheckedOption] = useState<number | undefined>(
    undefined,
  )
  const theme = useMantineTheme()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    setCheckedOption(i)
    onChange?.(e)
  }

  return (
    <Group className={classes.radioGroup}>
      {data.map((option, i) => (
        <Radio
          key={option}
          checked={initValue === option || checkedOption === i}
          className={classes.radioInput}
          color={theme.other.colors.darkGreen}
          label={option}
          onChange={e => handleChange(e, i)}
          size="md"
          value={option}
          {...props}
        />
      ))}
    </Group>
  )
}
